import React, { useMemo, useState } from 'react';
import DHeader from '../../pieces/DHeader';
import DText from '../../pieces/DText';
import DCode from '../../pieces/DCode';

export default function AgentTools() {

    return (
        <div>
            <DHeader>Agent Tools</DHeader>
       
            <DText>
              After setting up the reasoner, you need to provide the Agent tools to perform the task. At the moment,
              Laeyerz supports tools in the form of Python functions, as shown below.
            
            </DText>
            <DText>
              Let us say, we have a Python function that calculates the total for a given list of items.
            </DText>
            
            <DCode>
                {`#-------------- Total Calculator -------------------------------
def get_total(items: list):
    total = 0
    for item in items:
        if(item["available"]):
            total += item["price"]*item["quantity"]
        else:
            total += 0
    return {
        "total": total
    }
`}
            </DCode>

            <br />

            <DText>
              To add the tool to the Agent, we need to pass in the tool name, description, parameters and the function to the Agent.
              We use the add_tool method to add the tool to the Agent as shown below.
              </DText>


            <DCode>
                {`agent.add_tool({
    "name": "get_total",
    "description": "Get the total for a given list of items",
    "parameters": [
        {
            "name": "items",
            "type": "array",
            "description": "The items to get the total for"
        }
    ],
    "function": get_total
})
`}
            </DCode>
       
        </div>
    )
}